<template>
  <AdminModal
    :is-open="isOpen"
    modalSize="md"
    modal-title="결제 할인 코드 변경"
    :confirm="save"
    :close="close"
    confirmButtonTitle="변경"
    name="changeProductDiscountModal"
  >
    <b-container>
      <b-row>
        <b-col>
          <b-form-floating-label>
            기존
          </b-form-floating-label>
          <b-form-input
            id="input-1"
            v-model="oldString"
            type="text"
            required
          />
        </b-col>
        <b-col>
          <b-form-floating-label>
            변경
          </b-form-floating-label>
          <b-form-input
            id="input-1"
            v-model="newString"
            type="text"
            required
          />
        </b-col>
      </b-row>
    </b-container>
  </AdminModal>
</template>

<script>
import api from "@/api/api"
import AdminModal from "@/components/modals/AdminModal.vue";

export default {
  name: "ChangeProductDiscountModal",
  components: {AdminModal},
  props: ['isOpen', 'reload', 'close', 'currentString'],
  data() {
    return {
      oldString:"",
      newString: "",
    }
  },
  mounted() {
    this.oldString = this.currentString
  },
  methods: {
    save() {
      if (this.newString.length === 0) {
        this.$toast.error('변경할 코드값을 입력해주세요.',
          {
            position: "top-right",
            duration: 2000
          })
        return
      }

      if (
        !this.oldString.match(/^[a-zA-Z0-9가-힣_]+/) || 
        !this.newString.match(/^[a-zA-Z0-9가-힣_]+/)
      ) {
        this.$toast.error('변경할 코드값을 확인해주세요.',
          {
            position: "top-right",
            duration: 2000
          })
        return
      }

      const params = {
        oldCode: this.oldString,
        newCode: this.newString
      }
      api.productLessonDiscount.updatePrefixCode(params, () => {
        this.reload();
        this.close();
      }, (error) => {
        console.log(error)
        const errorData = error.response.data
        this.$toast.show(errorData.message,
          {
            type: "error",
            position: "top-right",
            duration: 2000,
            max: 10
          });
        return
      })
      
    }
  }
}
</script>

<style scoped>

</style>